import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { UsersService } from '../services/users.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  public user$: Observable <any> = this._auth._authfb.user;
  detailUser;

  constructor(
    public _auth: AuthService, 
    public router: Router,
    private _users: UsersService
  ) { }

  async canActivate():Promise<boolean> {

    return await new Promise( (resolve, reject) => {

      try {
        this.user$.subscribe( data => {
          this.detailUser = data;
          if(this.detailUser.email){
            
            this._users.getAuthorization(data.email, 'editor').then( result => {
              resolve(result);
            });

          }else{

            resolve(false);
            
          }
        });

      } catch (error) {
        console.error({error})
        reject(false)
      }

    })

  }


}
